export default {
  id: "page13",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      label: "Proszę zaznaczyć jedną wybraną odpowiedź"
    },
    {
      label:
        "Czy w sezonie owocowym przygotowuje Pan(i) przetwory z owoców przy użyciu środków żelujących typu Żelfix, cukier żelujący?",
      number: "24",
      type: "radio",
      id: "kategoria8_owoce",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page13.js